// extracted by mini-css-extract-plugin
export default {"error":"fc10fd5e06c0"};